import React from "react";
import "../Download/DownloadDropdown.scss";

export const DownloadIcon = () => {
  return (
    <div className="download-animation-wrapper">
      <svg
        className="download-arrow"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 2.25C12.4142 2.25 12.75 2.58579 12.75 3V13.1893L16.4697 9.46967C16.7626 9.17678 17.2374 9.17678 17.5303 9.46967C17.8232 9.76256 17.8232 10.2374 17.5303 10.5303L12.5303 15.5303C12.2374 15.8232 11.7626 15.8232 11.4697 15.5303L6.46967 10.5303C6.17678 10.2374 6.17678 9.76256 6.46967 9.46967C6.76256 9.17678 7.23744 9.17678 7.53033 9.46967L11.25 13.1893V3C11.25 2.58579 11.5858 2.25 12 2.25Z"
          fill="#17142A"
        />
      </svg>

      <svg
        className="download-box"
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="6"
        viewBox="0 0 14 6"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1 0.5C1.27614 0.5 1.5 0.723858 1.5 1V1.8C1.5 2.3683 1.50039 2.76446 1.52559 3.07288C1.55031 3.37546 1.5964 3.54931 1.66349 3.68099C1.8073 3.96323 2.03677 4.1927 2.31901 4.33651C2.45069 4.4036 2.62454 4.44969 2.92712 4.47441C3.23554 4.49961 3.6317 4.5 4.2 4.5H9.8C10.3683 4.5 10.7645 4.49961 11.0729 4.47441C11.3755 4.44969 11.5493 4.4036 11.681 4.33651C11.9632 4.1927 12.1927 3.96323 12.3365 3.68099C12.4036 3.54931 12.4497 3.37546 12.4744 3.07288C12.4996 2.76446 12.5 2.3683 12.5 1.8V1C12.5 0.723858 12.7239 0.5 13 0.5C13.2761 0.5 13.5 0.723858 13.5 1V1.82142C13.5 2.3633 13.5 2.80038 13.4711 3.15431C13.4413 3.51874 13.3784 3.83883 13.2275 4.13498C12.9878 4.60538 12.6054 4.98783 12.135 5.22752C11.8388 5.37841 11.5187 5.44132 11.1543 5.47109C10.8004 5.50001 10.3633 5.5 9.82142 5.5H4.17858C3.6367 5.5 3.19963 5.50001 2.84569 5.47109C2.48126 5.44132 2.16117 5.37841 1.86502 5.22752C1.39462 4.98783 1.01217 4.60538 0.772484 4.13498C0.62159 3.83883 0.558684 3.51874 0.528909 3.15431C0.499991 2.80037 0.499995 2.3633 0.5 1.8214L0.5 1C0.5 0.723858 0.723858 0.5 1 0.5Z"
          fill="#2B244C"
        />
      </svg>
    </div>
  );
};
